import { resolveDynamicComponent as _resolveDynamicComponent, toHandlers as _toHandlers, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_field_block = _resolveComponent("g-field-block");
    return (_openBlock(), _createBlock(_component_g_field_block, _mergeProps(_ctx.$attrs, {
        name: _ctx.dataMember,
        "error-message": _ctx.errorMessage,
        label: _ctx.label
    }), {
        "g-field-input": _withCtx(({ identification, error, disabled, size, setFocusClass, removeFocusClass, hasSuffix, hasPrefix }) => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getComponent), _mergeProps({
                ref: "txtInput",
                id: identification,
                name: identification,
                placeholder: _ctx.placeholder,
                validationStatus: _ctx.validationState,
                "show-clear-button": _ctx.showClearButton,
                "input-attr": _ctx.inputAttrInternal,
                modelValue: _ctx.internalValue,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.internalValue) = $event))
            }, _ctx.getComponentOptions, _toHandlers(_ctx.getComponentEvents), {
                onEnterKey: _ctx.onEnterKey,
                onFocusOut: _ctx.onFocusOut
            }), null, 16, ["id", "name", "placeholder", "validationStatus", "show-clear-button", "input-attr", "modelValue", "onEnterKey", "onFocusOut"]))
        ]),
        _: 1
    }, 16, ["name", "error-message", "label"]));
}
